import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Button } from '@/components/ui/Button';

export interface TablePaginationProps {
  page: number;
  totalPages: number;
  totalElements?: number;
  onPageChange: (page: number) => void;
  loading?: boolean;
  hasRows?: boolean;
  className?: string;
}

/** Shared prev/next footer for DataTable and custom table layouts. */
export function TablePagination({
  page,
  totalPages,
  totalElements,
  onPageChange,
  loading = false,
  hasRows = true,
  className = '',
}: TablePaginationProps) {
  if (totalPages <= 0 || loading || !hasRows) return null;

  return (
    <div
      className={`flex items-center justify-between border-t border-slate-200/80 px-4 py-3 dark:border-slate-800 ${className}`}
    >
      <span className="text-sm text-slate-500 dark:text-slate-400">
        Page {page + 1} of {totalPages}
        {totalElements !== undefined && ` · ${totalElements} total`}
      </span>
      <div className="flex gap-1">
        <Button
          type="button"
          variant="secondary"
          size="sm"
          className="!px-2"
          disabled={page <= 0}
          onClick={() => onPageChange(page - 1)}
          aria-label="Previous page"
        >
          <ChevronLeftIcon fontSize="small" />
        </Button>
        <Button
          type="button"
          variant="secondary"
          size="sm"
          className="!px-2"
          disabled={page >= totalPages - 1}
          onClick={() => onPageChange(page + 1)}
          aria-label="Next page"
        >
          <ChevronRightIcon fontSize="small" />
        </Button>
      </div>
    </div>
  );
}
